module.exports = __webpack_public_path__ + "img/checked.583b7611.svg";